import client from '../client';
import endpoints from '../endpoints';

/**
 * 배너 — 관리자 + 공개 API
 * BE: /api/admin/banners (CRUD) / /api/main/banners (Public)
 */

/* ── 관리자 ── */

export const adminGetBanners = async (params = {}) => {
  const res = await client.get(endpoints.admin.banners.list, { params });
  return res.data;
};

export const adminCreateBanner = async (data) => {
  const res = await client.post(endpoints.admin.banners.list, data);
  return res.data;
};

export const adminUpdateBanner = async (id, data) => {
  const res = await client.put(endpoints.admin.banners.detail(id), data);
  return res.data;
};

export const adminDeleteBanner = async (id) => {
  const res = await client.delete(endpoints.admin.banners.detail(id));
  return res.data;
};

// #241: 배너 오버레이 텍스트 다국어 자동번역(DeepL) — translations 캐시에 upsert. best-effort 호출용.
export const adminAutoTranslateBanner = async ({ row_id, fields }) => {
  const res = await client.post(endpoints.admin.translations.autoTranslate, {
    table_name: 'banners',
    row_id,
    fields,
  });
  return res.data;
};

/* ── 공개 ── */

export const getMainBanners = async () => {
  const res = await client.get(endpoints.main.banners);
  return res.data;
};

/**
 * GET /api/main/banners?service=X — 서비스별 고정 배너(현재 언어 우선, 없으면 공통).
 * 단일 배너 객체 반환(없으면 null). 응답에 image_url(데스크탑)/image_mobile_url(모바일)/link_url 포함.
 */
export const getServiceBanner = async (service) => {
  const params = service ? { service } : {};
  const res = await client.get(endpoints.main.banners, { params });
  const list = Array.isArray(res.data) ? res.data : [];
  return list[0] || null;
};
